import packageInfo from '../../package.json';
export default packageInfo.version;